import React, { useEffect, useState, useRef  } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import apiClient from "../BaseUrl/apiClient";
import "../css/App.css";
import "../css/color.css";
import _ from "lodash";
import TokenService from "../service/TokenService";
import SriyanshCardHeader from "../components/CardHeader";
import SearchTextField from "../CustomComponant/SearchTextField";
import ListDynamicTable from "../CustomComponant/ListDynamicTable";
import {DISPLAY_PAGE_SIZE} from "../constants/constants"


function POSearch({ setUserData }) {
  const [returnData, setReturnData] = useState([]);
  const [totalRows, setTotalRows] = useState("");
  const [srcinddata, setSrcinddata] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const pageSize = DISPLAY_PAGE_SIZE;
  const navigate = useNavigate();
  const uname = TokenService.getUserDetails()?.uname;

  // Ref to hold the debounced function
  const fetchDataRef = useRef();

  useEffect(() => {
    fetchDataRef.current = _.debounce(async (searchTerm, page) => {
      try {
        const response = await apiClient.post("/searchPOList", {
          uname,
          limit: String(pageSize * (page - 1)),
          offset: String(pageSize),
          srcinddata: searchTerm,
        });
        setReturnData(response.data);
        setTotalRows(response.data[0]?.totaldata || 0);
      } catch (error) {
        setReturnData([]);
        setTotalRows(0);
      }
    }, 300);
  }, [uname, pageSize]);

  // Call the debounced function when input or page changes
  useEffect(() => {
    if (fetchDataRef.current) {
      fetchDataRef.current(srcinddata, currentPage);
    }
  }, [srcinddata, currentPage]);

  const handleRowClick = (row) => {
    viewData(row.ponumber);
  };

  const viewData = (e) => {
    navigate("searchpodata", {
      state: {
        po_id: e,
      },
    });
  };



 // console.log("Return Data:   here i m ");
  const columns = [
    "ponumber",
    "POItemName",
    "poreceiptdate",
    "POConsignee",
    "DPDate",
    "IndentNumber",
  ];
  const columnNames = [
    "PO Number",
    "Item Name",
    "PO Date",
    "Consignee",
    "DP Date",
    "Indent Number",
  ];

  return (
    <div>
      <Card className="Formcard">
        <div className="input-groupHeading">Search by PO Number</div>
        <CardContent>
          {currentPage === 1 ? (
            <SearchTextField
              label="PO Number"
              value={srcinddata}
              title="Enter PO Number"
              onChange={(e) => setSrcinddata(e.target.value)}
              adornment={
                <IconButton title="Search PO">
                  <SearchIcon />
                </IconButton>
              }
            />
          ) : null}
          <ListDynamicTable
            columns={columns}
            columnNames={columnNames}
            data={returnData}
            totalRows={totalRows}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            onRowClick={handleRowClick}
          />
        </CardContent>
      </Card>
    </div>
  );
}

export default POSearch;